// 设置特殊原生头配置
export const MYBEAN = {
    iconType: 'question', // 客户端吐传iconType，用来判断点击事件处理逻辑
    textType: 'beanDetail', // 客户端吐传textType，用来判断点击事件处理逻辑
    text: '使用明细', // 设置原生头右上角文案
    iosIconName: 'colorBean_TopBarTitleIcon_Name' // iOSicon名称
}

// 3.1.2以上版本使用原生头页面白名单
export const NATIVEHEADPAGE = ['/myBean', '/vatInfo', '/vatForm', '/deliveryAddressForm', '/beanDetail', '/beanPolicy']


// WEBPACK FOOTER //
// ./src/common/js/nativeType.js